import React from 'react';

/**
 * Visual indicator for optimistic update operations
 * Shows pending, success, and failed states
 */
const OperationStatusIndicator = ({ operationStatus }) => {
  const operations = Array.from(operationStatus.entries());

  if (operations.length === 0) {
    return null;
  }

  const pendingCount = operations.filter(([, data]) => data.status === 'pending').length;
  const failedOps = operations.filter(([, data]) => data.status === 'failed');

  return (
    <div className="operation-status-container">
      {pendingCount > 0 && (
        <div className="operation-status pending">
          <div className="status-spinner"></div>
          <span>
            Syncing {pendingCount} change{pendingCount > 1 ? 's' : ''}...
          </span>
        </div>
      )}

      {failedOps.map(([operationId, data]) => (
        <div key={operationId} className="operation-status failed">
          <svg className="status-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10" strokeWidth="2" />
            <line x1="15" y1="9" x2="9" y2="15" strokeWidth="2" />
            <line x1="9" y1="9" x2="15" y2="15" strokeWidth="2" />
          </svg>
          <span>Action failed: {data.error?.response?.data || data.error?.message || 'Unknown error'}</span>
        </div>
      ))}
    </div>
  );
};

export default OperationStatusIndicator;
